import { render, staticRenderFns } from "./SetPos.vue?vue&type=template&id=42c3134d&"
import script from "./SetPos.vue?vue&type=script&lang=js&"
export * from "./SetPos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports